// hooks/useScroll.js
import { useState, useEffect } from 'react';

/**
 * Whether the window has scrolled past `threshold` pixels (drives the sticky
 * header style). Side effect: one `scroll` listener on window while mounted.
 * @param {number} [threshold=50]
 * @returns {boolean}
 */
const useScroll = (threshold = 50) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > threshold);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return isScrolled;
};

export default useScroll;
